/**
 * PackCpfDialog — modal de CPF da 1ª compra de pacote (sem CPF salvo).
 *
 * JSX movido VERBATIM do IntegrationsPage.jsx (plano 19, TODO 1.3) para as duas telas de compra
 * (Integrações e /billing) usarem o mesmo modal. Não é View nova: é o que já existia, num arquivo só.
 * Estado e handlers vêm de usePackPurchase (cpfDialog).
 */
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

export default function PackCpfDialog({ open, cpf, setCpf, cpfError, cpfSubmitting, onCancel, onSubmit }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Digite seu CPF para gerar o QR Code</DialogTitle>
      <DialogContent>
        <TextField autoFocus fullWidth label="CPF" value={cpf} onChange={(e) => setCpf(e.target.value)}
          error={!!cpfError} helperText={cpfError || 'Só na 1ª compra. Fica salvo para as próximas.'} sx={{ mt: 1 }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={cpfSubmitting}>Cancelar</Button>
        <Button variant="contained" onClick={onSubmit} disabled={cpfSubmitting}>Gerar QR Code</Button>
      </DialogActions>
    </Dialog>
  );
}
